/**
 * 远期房态组件取数：从整店 storeData 中取 roomStatusRecently 片段
 */
export function useRoomStatusRecentlyData(storeData) {
    var _a;
    return (_a = storeData === null || storeData === void 0 ? void 0 : storeData.roomStatusRecently) !== null && _a !== void 0 ? _a : { baseChartData: [] };
}
